import { RefObject, useEffect, useState } from 'react';

import { getDeviceBrowserInfo } from '@gem/utils';

interface IMediaPlayerSpeedOptions {
  url: string | null;
  mediaRef: RefObject<HTMLMediaElement>;
  speed: number;
}

interface IMediaPlayerSpeed {
  currentSpeed: number;
  setSpeed(speed: number): void;
}

export function useMediaPlayerSpeed({
  url,
  mediaRef,
  speed,
}: IMediaPlayerSpeedOptions): IMediaPlayerSpeed {
  const [currentSpeed, setSpeed] = useState(speed);

  useEffect(() => {
    const ref = mediaRef.current;

    if (!ref) {
      return;
    }

    ref.playbackRate = currentSpeed;

    if (!getDeviceBrowserInfo().isSafari) {
      return;
    }

    // Safari fix: reapply playbackRate after `loadstart` resets it to 1.
    const onRateChange = (): void => {
      ref.playbackRate = currentSpeed;
    };

    ref.addEventListener('ratechange', onRateChange);

    return () => {
      ref.removeEventListener('ratechange', onRateChange);
    };
  }, [currentSpeed, url]);

  return { currentSpeed, setSpeed };
}
